import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditServiceOrderForm from './EditServiceOrderForm'
import ModalHeader from './ModalHeader'
import ParentLoader from './_load/ParentLoader'
import ServiceOrderLoader from './_load/ServiceOrderLoader'

const EditServiceOrderModal = props => {
  return (
    <ControlledModal width="46rem" disableClickOutside {...props}>
      <PermissionChecker any={['createServiceOrder', 'editServiceOrder']}>
        <ParentLoader>
          <ModalHeader />
          <ServiceOrderLoader>
            <EditServiceOrderForm />
          </ServiceOrderLoader>
        </ParentLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditServiceOrderModal
